require('./bootstrap');

import views from '@/Support/View';

document.addEventListener('DOMContentLoaded', () => {
    views.start();

    // if (window.tippy) {
    //     tippy('[data-tippy-content]');
    // }
});
